import { Launcher } from '../../entities/launcher.type';
import { ILauncherFeature } from '../../../interfaces/launcher-feature.interface';
import { RssTickerConfigs } from '../../entities/rss-ticker.type';
import { PlaylistItemLinkModel } from './playlist-item-link.model';
import { AppConstants } from '../../../../app.constants';
import { PlaylistItemBorderSettings } from './playlist-item-border-settings.model';
import { SortOrder } from '../../entities/sort-order.type';
import { TimerConfig } from '../../entities/timer-config.type';

export class PlaylistItemDTO {

  public Id: number;
  public PlaylistId: number;
  public PlaylistItemType: number;
  public PlaylistItemTitle: string;
  public PlaylistFileName: string;

  public OpenInFullScreen: Boolean;
  public SkipIfNoInternet: boolean;
  public IncognitoMode: boolean;
  public IsMuted: boolean;
  public LauncherId: number;
  public Duration: string;
  public FolderItemDuration: string;
  public UseExactFolderDuration: boolean;
  public ExactVideoDuration: string;
  public CustomParameters: string;
  public IsContentStretched: boolean;

  public Position: number;
  public LocalLauncher: string;
  public Launcher: Launcher;
  public IsLocal: boolean;
  public launcherFeatures: ILauncherFeature[];
  public isToChangeExisted: boolean = false;
  public LayoutSplitViewType: number;
  public RssConfigs: RssTickerConfigs;
  public TimerConfig: TimerConfig;
  public PlaylistItemLinks: PlaylistItemLinkModel[];
  public BordersSettings: PlaylistItemBorderSettings;
  public IsLead: boolean;
  public Order: SortOrder;

  public PdfScrollEnabled: boolean;
  public SecondsToScrollPdfPage: number;
  public PdfPageDuration: string;

  public percentage?: number;
  public audioFileDuration?: any;
  public useExactDuration?: boolean;
  public isSelected?: boolean;

  constructor() {
    this.Duration = AppConstants.DEFAULT_PLAYLIST_ITEM_DURATION;
    this.PlaylistItemLinks = [];
  }
}
